import { IIdsRequest } from "../../model/request/IIdsRequest";
import { ThiSinhGenerateSBDRequest } from "../../model/request/tct/IDanhSoBaoDanhRequest";
import { IThiSinhSelectDanhPhachVmRequest } from "../../model/request/tct/IThiSinhSelectDanhPhachVmRequest";
import { IThiSinh } from "../../model/respone/tct/IThiSinh";
import { apiClient } from "../apiClient";
import { PHONG_THI_API } from "./phongThiApi";
import { DOT_THI_API } from "./dotThiApi";

export const THI_SINH_API = "thi-sinh";
export const thiSinhApi = {
  SelectAll: () => apiClient.get(`${THI_SINH_API}`),
  SelectByPhong: (phongThiId: number) => apiClient.get(`${PHONG_THI_API}/${phongThiId}/thi-sinh`),

  SelectByPhongs: (request: IThiSinhSelectDanhPhachVmRequest) => apiClient.post(`${THI_SINH_API}/select-by-phongs`, request),
  Insert: (payload: IThiSinh) => apiClient.post(`${THI_SINH_API}`, payload),
  Update: (payload: IThiSinh) => apiClient.put(`${THI_SINH_API}`, payload),
  Updates: (payload: IThiSinh[]) => apiClient.put(`${THI_SINH_API}/saves`, payload),
  Deletes: (id: IIdsRequest) => apiClient.post(`${THI_SINH_API}/deletes`, id),
  GenerateSBD: (rq: ThiSinhGenerateSBDRequest) => apiClient.put(`${THI_SINH_API}/sbd`, rq),
  SelectLichThiAsync: (rq: any) => apiClient.post(`${THI_SINH_API}/select-lich-thi`, rq),
  SelectLichThiPrintAsync: (rq: any) => apiClient.post(`${THI_SINH_API}/select-lich-thi-html`, rq),
  SelectChuaLapKeHoachAsync: (id_dot_thi: number) => apiClient.get(`dot-thi/${id_dot_thi}/thi-sinh/chua-tao-lich`),
  ReadAndValidateImportData: (payload: any) => apiClient.post(`${THI_SINH_API}/import/read-and-validate`, payload),
  Import: (payload: any) => apiClient.post(`${THI_SINH_API}/import`, payload),
  SelectAllByDotThi: (id_dot_thi: number) => apiClient.get(`${THI_SINH_API}/select-by-dot-thi/${id_dot_thi}`),
  KiemTraNhapDiem: (id_dot_thi: number) => apiClient.get(`${DOT_THI_API}/${id_dot_thi}/thi-sinh/kiem-tra-nhap-diem`),
  CapNhatLanThiNhapDiem: (id_dot_thi: number) => apiClient.put(`${DOT_THI_API}/${id_dot_thi}/thi-sinh/cap-nhat-lan-thi-nhap-diem`),
  DongBoLanThiNhapDiem: (id_dot_thi: number) => apiClient.put(`${DOT_THI_API}/${id_dot_thi}/thi-sinh/dong-bo-lan-thi-nhap-diem`),
};
